import React from 'react'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectAllItems } from '../features/posts/postsSlice'


const Sidebar = () => {
  const posts = useSelector(selectAllItems);
  const length = posts.length;
  const title = "Your Daily plans"

  const [name, setName] = useState('Didy')
  const HandleClick = () => {
    const names = ['Microverse', 'LWG', 'User'];
    const int = Math.floor(Math.random() * 3);
    setName(names[int]);
  }
  return (
    <div>
      <h1 onClick={ HandleClick }>
        Hello {name}!
      </h1>
        
      <p>{`You've got ${length} ${length===1 ? 'post' : 'posts'} in ${title}`}</p>
    </div>
  )
}

export default Sidebar